import { PriceManager } from './priceManager';
import { Slider } from './slider';

export class Calculator {
  matarialCount: Slider;

  result: HTMLElement;

  priceManager: PriceManager;

  downloadsCount: Slider;

  constructor(
    matarialCountSlider: Slider,
    downloadsCountSlider: Slider,
    priceManager: PriceManager,
    result: HTMLElement,
  ) {
    this.matarialCount = matarialCountSlider;
    this.downloadsCount = downloadsCountSlider;
    this.priceManager = priceManager;
    this.result = result;
    matarialCountSlider.addSubscription(() => this.updateResultSection());
    downloadsCountSlider.addSubscription(() => this.updateResultSection());
    priceManager.addSubscription(() => this.updateResultSection());

    this.updateResultSection();
  }

  updateResultSection() {
    const materialCost = ((this.downloadsCount.value * this.priceManager.value) / 2) * this.matarialCount.value;
    const result = (materialCost * 30).toLocaleString('ru-RU');
    window.requestAnimationFrame(() => {
      this.result.innerText = `${result} руб`;
    });
  }
}
